module.exports = __webpack_public_path__ + "img/SCC_Endothelial.a26bbe61.png";